module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/spinner-27e2ef14.svg";